export const faqData = [
  {
    id: 1,
    question: 'What is Swirl?',
    answer:
      'Swirl is a Liquid Staking solution, allowing users to stake IOTA and receive stIOTA in return. These tokens provide instant liquidity, enabling users to trade, use them as collateral in DeFi, or earn additional rewards while their IOTA remains staked. Swirl enhances staking accessibility, flexibility, and capital efficiency, making it a key component of the IOTA DeFi ecosystem.',
  },
  {
    id: 2,
    question: 'What is stIOTA?',
    answer:
      'stIOTA is the liquid staking token issued by Swirl when users stake their IOTA. It represents a redeemable claim on staked IOTA, allowing users to:' +
      '<ul><li>Maintain liquidity while earning staking rewards.</li>' +
      '<li>Trade stIOTA on secondary markets.</li>' +
      '<li>Use it as collateral in DeFi protocols for additional yield opportunities.</li></ul>' +
      'As staking rewards accrue, the value of stIOTA increases relative to IOTA, ensuring users benefit from staking while retaining flexibility and composability in the IOTA DeFi ecosystem.',
  },
  {
    id: 3,
    question: 'How to Use stIOTA?',
    answer:
      'stIOTA is a liquid staking token that unlocks multiple opportunities within the IOTA DeFi ecosystem. Users can:</li>' +
      '<ul><li>Redeem stIOTA for IOTA when unstaking through Swirl.</li>' +
      '<li>Trade stIOTA on decentralized exchanges (DEXs).</li>' +
      '<li>Use it as collateral in lending protocols to borrow assets.</li>' +
      '<li>Provide liquidity in DeFi pools to earn additional rewards.</li>' +
      '<li>Participate in yield farming to maximize returns.</li></ul>' +
      'With stIOTA, users can earn staking rewards while maintaining flexibility and liquidity, making it a powerful asset within the IOTA ecosystem.',
  },
  {
    id: 31,
    question: 'How is APY calculated?',
    answer:
      'APY on Swirl is calculated this way:<br />' +
      'APY = validator_rewards_apy × 0.9' +
      '<ul><li><b>Validator rewards</b> — variable part that depends on validator performance, reduced by 10% Swirl Staking Fee.</li>' +
      '<li>It is calculated using ratio updates over the protocol lifetime.</li></ul>' +
      'This approach gives a more accurate and up-to-date reflection of the network rewards.',
  },
  {
    id: 4,
    question: 'IOTA Staking Limits',
    answer:
      'Swirl’s liquid staking offers flexible participation, allowing users to stake and unstake IOTA with the following limits:</li>' +
      '<ul><li>Minimum staking amount: 1 IOTA</li>' +
      '<li>Maximum staking amount in a single deposit: 5 million IOTA.</li>' +
      '<li>Maximum staking amount: No limits</li>' +
      '<li>Minimum unstaking amount: 1 stIOTA</li></ul>',
  },
  {
    id: 5,
    question: 'Unstaking Timeframe',
    answer:
      'Swirl provides an instant unstake mechanism, allowing users to burn stIOTA and immediately receive IOTA. This eliminates traditional lock-up periods, ensuring maximum liquidity while maintaining network stability.<br/>' +
      'Key details about unstaking with Swirl:<br/>' +
      '<ul><li>Instant Redemption: Users can unstake at any time by converting stIOTA back to IOTA.</li>' +
      '<li>Dynamic Fee Structure: A small fee is applied to instant unstake requests to regulate liquidity and prevent excessive withdrawals.</li>' +
      '<li>Efficient Validator Withdrawals: The contract optimally retrieves IOTA from low-priority validators first, ensuring a balanced staking distribution.</li></ul>' +
      'Swirl’s smart contract architecture guarantees a secure and decentralized unstaking process, giving users full control over their assets without the constraints of traditional staking.',
  },
  {
    id: 6,
    question: 'Earning Rewards',
    answer:
      'By staking IOTA with Swirl, users automatically accrue daily staking rewards. These rewards are seamlessly integrated into the protocol, increasing the value of stIOTA over time.<br/><br/>' +
      'Key points about rewards:<br/>' +
      '<ul><li>Auto-compounding: Rewards are automatically funneled into the staking pool, eliminating the need for manual claims.</li>' +
      '<li>stIOTA Value Appreciation: As rewards accumulate, the stIOTA-to-IOTA ratio gradually increases, reflecting its growing worth.</li>' +
      '<li>Initial Conversion Rate: The starting ratio for stIOTA to IOTA is 1:1, but over time, stIOTA appreciates relative to IOTA as staking rewards accrue.</li></ul>' +
      'Swirl ensures that users earn rewards passively, while maintaining the flexibility of liquid staking.',
  },
  {
    id: 7,
    question: 'Rewards Distribution',
    answer:
      'Once you stake your IOTA with Swirl, reward accumulation begins immediately. Rewards are automatically distributed daily, increasing the value of stIOTA relative to IOTA over time.<br/><br/>' +
      'This seamless distribution ensures that users benefit from staking rewards without needing manual claims, making staking with Swirl both efficient and user-friendly.',
  },
  {
    id: 8,
    question: 'Swirl Staking Fees',
    answer:
      'Swirl charges a 10% fee on the APY, which is redistributed to token holders. This fee is separate from any validator-level staking fees, which may vary depending on the staking infrastructure used.<br/><br/>' +
      'Key points about Swirl’s fee structure:' +
      '<ul><li>The 10% fee is applied only to earned rewards, not the initial stake.</li>' +
      '<li>Validator staking fees are factored into the displayed APY, ensuring transparency.</li></ul>',
  },
  {
    id: 9,
    question: 'Potential Risks',
    answer:
      'Staking IOTA through Swirl is designed to be secure and reliable. However, as with any blockchain-based system, some risks exist, particularly in liquid staking scenarios. These include:<br/>' +
      '<ul><li>Smart Contract Risks: Although Swirl undergoes rigorous audits by <a href="https://hacken.io/" target="_blank" rel="noreferrer">reputable security firms</a>, vulnerabilities in smart contracts can pose a risk.</li>' +
      '<li>Validator Risks: We mitigate slashing and downtime risks by partnering with trusted and high-performance validators.</li>' +
      '<li>Centralization Concerns: To maintain decentralization, Swirl ensures that stake is distributed across multiple validators, preventing over-concentration</li></ul>' +
      'By prioritizing security, decentralization, and transparency, Swirl minimizes risks while providing a seamless and efficient liquid staking experience.',
  },
];
